import { render, staticRenderFns } from "./InstallPWA.vue?vue&type=template&id=491b816f"
import script from "./InstallPWA.vue?vue&type=script&lang=js"
export * from "./InstallPWA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports